export default __webpack_public_path__ + "static/media/doctor_2.cb8ef3c9.png";